export default [{
    path: '/*',
    component: () => import('./home/nlpcc-track1.vue')
}]